<template>
  <v-data-table
    id="affiliateMainTable"
    :items="statisticsData"
    :headers="cols"
    class="anty-user-panel-affiliate-main-table"
    hide-default-footer
    disable-sort
    :no-data-text="noDataText"
  >
    <!-- Sub account -->
    <template #[`item.subAccount`]="{item}">
      {{ getSubAccountText(item) }}
    </template>

    <!-- ПОЛЬЗОВАТЕЛЬ -->
    <template #[`item.user`]="{item}">
      <span v-if="item && item.donor">
        {{ item.donor.username }}
      </span>
    </template>

    <!-- ДАТА -->
    <template #[`item.date`]="{item}">
      <span class="text-no-wrap">
        {{ formatDate(item.created_at) }}
      </span>
    </template>

    <!-- СУММА -->
    <template #[`item.sum`]="{item}">
      <div class="text-no-wrap text-end">
        {{ `$ ${item.transaction_usd}` }}
      </div>
    </template>

    <template #footer>
      <v-pagination
        :value="pagination.currentPage"
        :length="pagination.lastPage"
        :total-visible="pagination.perPage"
        class="custom-pagination"
        color="unset"
        @next="updateFooterOptions(pagination.currentPage + 1)"
        @previous="updateFooterOptions(pagination.currentPage - 1)"
        @input="updateFooterOptions($event)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from 'vuex'
import formatDate from '@/mixins/timestampDateFormat'

export default {
  name: 'AffiliateMainTable',
  mixins: [
    formatDate
  ],
  computed: {
    ...mapGetters({
      statisticsData: 'affiliate/statisticsData',
      statisticsFilters: 'affiliate/statisticsFilters',
      pagination: 'affiliate/statisticsPagination',
      profile: 'main/profile'
    }),
    areFiltersSet() {
      return (
        this.statisticsFilters.selectedSubAccounts.length ||
        this.statisticsFilters.statisticsDate.value !== 'forAllTheTime' ||
        this.statisticsFilters.statisticsDate.dateFrom !== '' ||
        this.statisticsFilters.statisticsDate.dateTo !== ''
      )
    },
    noDataText() {
      return this.areFiltersSet ?
        this.$t('affiliateProgram.transactions.nothingFoundByFilters') :
        this.$t('affiliateProgram.transactions.noTransactionsAvailable')
    },
    cols() {
      return [
        {
          text: this.$t('affiliateProgram.links.subAccount'),
          value: 'subAccount',
          width: 240
        },
        {
          text: this.$t('affiliateProgram.mainTable.user'),
          value: 'user',
          width: 270
        },
        {
          text: this.$t('affiliateProgram.mainTable.date'),
          value: 'date',
          width: 140
        },
        {
          text: this.$t('affiliateProgram.mainTable.amount'),
          value: 'sum',
          width: 80,
          class: 'text-end'
        },
      ]
    },
  },
  methods: {
    getSubAccountText(item) {
      return item.source === 'MAIN-LINK#' ? `${location.origin}/a/${this.profile.id}` : item.source
    },
    updateFooterOptions(selectedPage) {
      if (selectedPage < 1 || selectedPage > this.pagination.lastPage) return;

      this.$store.dispatch('affiliate/loadStatistics', selectedPage);
    }
  }
}
</script>

<style lang="scss">
.custom-pagination {
  margin-top: 24px;

  .v-pagination {
    justify-content: flex-start;
    display: flex;
    column-gap: 8px;


    .v-pagination__navigation {
      border: 1px solid var(--v-pagination-icon-default-base);

      i {
        color: var(--v-pagination-icon-default-base);
        width: 16px;
        height: 16px;
      }
    }

    .v-pagination__item {
      border: 1px solid var(--v-pagination-border-default-base);
    }

    .v-pagination__item.v-pagination__item--active {
      border: 1px solid var(--v-pagination-border-active-base);
      background-color: var(--v-pagination-background-active-base);
      color: var(--v-text-brand-base);
    }

    .v-pagination__navigation,
    .v-pagination__item,
    .v-pagination__item.v-pagination__item--active {
      margin: 0;
      display: flex;
      width: 40px;
      height: 40px;
      padding: 8px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 8px;
      box-shadow: unset;
    }
  }
}
</style>
